/**
 * Frontend Version Configuration
 *
 * IMPORTANT: This version MUST match the backend version in backend/config.py
 * When backend version changes, this file must be updated accordingly.
 *
 * The version checking mechanism will compare this version with the backend
 * and trigger a page refresh if they don't match.
 */

export const VERSION_CONFIG = {
  /**
   * Current frontend version
   * Format: MAJOR.MINOR.PATCH (Semantic Versioning)
   *
   * MUST match: backend/config.py -> AppConfig.APP_VERSION
   */
  FRONTEND_VERSION: process.env.REACT_APP_VERSION || "0.0.0-local",

  /**
   * Current frontend build/release date.
   * Keep this aligned with the current CHANGELOG release header.
   */
  FRONTEND_BUILD_DATE: process.env.REACT_APP_BUILD_DATE || "local",

  /**
   * Application name
   * Should match backend app name for consistency
   */
  APP_NAME: "DatacenterAI",

  /**
   * Version check interval (in milliseconds)
   * Default: 5 minutes (300000ms)
   *
   * This controls how often the frontend checks for version updates
   */
  VERSION_CHECK_INTERVAL: 5 * 60 * 1000, // 5 minutes

  /**
   * Auto-refresh delay after version mismatch detected (in milliseconds)
   * Default: 3 seconds (3000ms)
   *
   * Time to show notification before automatically refreshing the page
   */
  AUTO_REFRESH_DELAY: 3000, // 3 seconds

  /**
   * Whether to enable version checking
   * Set to false to disable version checking (useful for development)
   */
  ENABLE_VERSION_CHECK: process.env.REACT_APP_ENABLE_VERSION_CHECK !== 'false'
};

export default VERSION_CONFIG;
